import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCommentExclamationIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 14a1 1 0 1 0-.0002 2A1 1 0 0 0 12 14Zm0-12A10.0003 10.0003 0 0 0 2 12a9.8901 9.8901 0 0 0 2.26 6.33l-2 2a.9999.9999 0 0 0-.21 1.09A1.0004 1.0004 0 0 0 3 22h9a10.0003 10.0003 0 0 0 10-10A10.0002 10.0002 0 0 0 12 2Zm0 18H5.41l.93-.93a1.0004 1.0004 0 0 0 .3-.71 1 1 0 0 0-.3-.7A8.0002 8.0002 0 0 1 9.6665 4.346 8 8 0 1 1 12 20Zm0-12a1 1 0 0 0-1 1v3a.9997.9997 0 0 0 1 1 1.0001 1.0001 0 0 0 1-1V9a1.0002 1.0002 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineCommentExclamationIcon
